import cloneDeep from 'lodash/cloneDeep';
import {
  IMPORT_CUSTOMER_APPOINTMENTS,
  CLEAR_CUSTOMER_APPOINTMENTS,
} from '../constants';
import {
  CANCEL_APPOINTMENT,
  APPOINTMENT_STATUS,
} from '../../appointments/constants';

function customerAppointments(state = [], action) {
  switch (action.type) {
    case IMPORT_CUSTOMER_APPOINTMENTS:
      return [...action.appointments];
    case CANCEL_APPOINTMENT:
      if (state.length) {
        let newCustomerAppointments = cloneDeep(state);
        newCustomerAppointments = newCustomerAppointments.map((appointment) => {
          if (appointment.id === action.appointmentId) {
            appointment.status = APPOINTMENT_STATUS.canceled;
          }
          return appointment;
        });
        return newCustomerAppointments;
      }
      return state;
    case CLEAR_CUSTOMER_APPOINTMENTS:
      return [];
    default:
      return state;
  }
}

export default customerAppointments;
